import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import TranscriptModal from './TranscriptModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function TranscriptButton(_ref) {
  var meetingId = _ref.meetingId,
    userId = _ref.userId,
    meetingTitle = _ref.meetingTitle,
    meetingStartTime = _ref.meetingStartTime;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTranscriptModal = _useState2[0],
    setShowTranscriptModal = _useState2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      variant: "transparent",
      size: "small",
      icon: "captions",
      onClick: function onClick() {
        return setShowTranscriptModal(true);
      },
      children: t('actions_show_transcript')
    }), showTranscriptModal && /*#__PURE__*/_jsx(TranscriptModal, {
      meetingId: meetingId,
      userId: userId,
      meetingTitle: meetingTitle,
      meetingStartTime: meetingStartTime,
      onClose: function onClose() {
        return setShowTranscriptModal(false);
      }
    })]
  });
}
export default TranscriptButton;